module.exports = __webpack_public_path__ + "img/3ds.61ba58fb.svg";